
import { Component, OnInit, Input, ViewContainerRef, ElementRef, Output, EventEmitter, ViewChild, AfterViewInit, Inject, Optional, ChangeDetectorRef, Renderer2, HostListener, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { Router } from "@angular/router";
import "rxjs/add/operator/finally";
import "rxjs/add/operator/map";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";
import { UbicacionesService } from "../../service/ubicaciones.service";
import { RestService } from "../../../../shared/rest.service";
import { BsDatepickerConfig, BsDatepickerDirective } from "ngx-bootstrap/datepicker";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { CustomValidator } from "../../../../shared/customValidators";
import { ItineraryService } from "../../../../shared/itinerary.service";
import { RoomConfigurationItem } from "./roomConfigurationItem";
import { searchPayload } from "../../../../utils/search-functions";
import { UserService } from "../../../../pages/com.usblick.common/auth/user.service";
import { ConfirmationModalComponent } from "../../../../shared/modals/confirmation-modal/confirmation-modal.component";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import * as dayjs from "dayjs";
import { of, Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { setting } from '../../../../../../setting';
import { ResultsSearchService } from 'app/home/results-search.service';
import CssFilterConverter from "css-filter-converter";
import { NotFoundModalComponent } from 'app/shared/modals/not-found-modal/not-found-modal.component';
import { DateRangePickerService } from 'app/shared/date-range-picker/date-range-picker.service';
import { FormOfflineComponent } from 'app/shared/form-offline/form-offline.component';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { NotificationService } from "app/shared/notifications/notification.service";


@Component({
  selector: "usb-hotels",
  templateUrl: "./hotels.component.html",
  styleUrls: ["./hotels.component.scss"],
  providers: [UbicacionesService],
})
export class HotelsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() _close: boolean = true;
  @Input() getClientsSettingAppBooking: any;
  // HOTELS (alojamiento) o PARKS (parques temáticos): comparten este formulario.
  @Input() mode: string = 'HOTELS';

  @Output() payload = new EventEmitter<any>();
  @Output() results = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() origin = new EventEmitter<any>();
  @Output() modal = new EventEmitter<string>();

  @ViewChild("dpDeparture") datepickerDeparture: BsDatepickerDirective;
  @ViewChild("dpArrival") datepickerArrival: BsDatepickerDirective;
  @ViewChild('cardSelectorRoom') cardSelectorRoom: ElementRef;
  @ViewChild("destination") myInputField: ElementRef;
  @ViewChild('configPassenger') configPassenger: HTMLElement;
  @ViewChild(DaterangepickerDirective) picker!: DaterangepickerDirective;
  @ViewChild('triggerButton') triggerButton: ElementRef
  @ViewChild('dateRangePicker') dateRangePicker: DaterangepickerDirective;
  @ViewChild('iconInfo') iconInfo!: ElementRef;
@ViewChild('auto') auto: MatAutocomplete;
  private calendarSync: DateRangePickerService;
  _findData: boolean;
  _resultsQuery: any;
  _form: FormGroup;
  _maxAdults: any;
  _maxChildren: any;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  isCollapsed = false;
  validate = false;
  selectedDestiny: any;
  _longDestination: string;
  destiny: any;
  roomsAndPassengers: string;
  minDateDeparture: Date;
  maxDateArrival: Date;
  bsConfig: object;
  dateRange: any = { start: null, end: null };
  isLoading_ = false;
  valueQtyChild:number = 0;
  showModal: boolean = false;
  titleModal: string = 'Advertencia';
  messageModal: string = 'Cree un file en la barra superior para poder iniciar una búsqueda';
  minDate: dayjs.Dayjs = dayjs().subtract(0, "days");
  maxDate: dayjs.Dayjs = dayjs().add(12, "month");
  destinationOptions: Observable<any[]> = of([]);
  destinationOptions_: Observable<any[]>= of([]);
  public routeUploadFile:any;
  bgClientColor: string;
  isHoverRoom: boolean;
  isHoverConfirm: boolean;
  public countriesData: any[] = [];
  public filteredCountries: any[] = [];
  public selectNationality: string = '';
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  agencyId:any;
  agencyCountry: any;
  startDate: any;
  endDate: any
  country: any;
  selectNationalityForm: boolean = false;
  selectNationalityName: string = '';
  isHoveredCancelDate: boolean;
  hotel_id: number;
  hotel_name: string = '';
  country_name: string = '';
  province_name: string = '';
  bsModalRef?: BsModalRef;
  componentResults: boolean = false;
  // Sub-tipos de alojamiento. Apartamentos y Yates quedan deshabilitados hasta que exista soporte en backend.
  accommodationTypes: { key: string; label: string; enabled: boolean; logo?: string }[] = [
    { key: 'HOTELS', label: 'Hoteles', enabled: true },
    { key: 'APARTMENTS', label: 'Apartamentos', enabled: false },
    { key: 'BOATS', label: 'Yates', enabled: false },
  ];
  selectedAccommodationType: string = 'HOTELS';
  // Tipos de parque del modo PARKS. Los que tienen logo lo muestran en lugar del texto.
  parkTypes = [
    { key: 'DISNEY', label: 'Walt Disney World', logo: 'assets/img/app/parks/wdw.svg', enabled: true },
    { key: 'UNIVERSAL', label: 'Universal Orlando Resort', logo: 'assets/img/app/parks/universal.svg', enabled: true },
    { key: 'OTHERS', label: 'Otros', logo: '', enabled: true },
  ];
  // Opciones del diseño de parques. Todavía no se envían en el payload.
  parkOptions = { ticket: false, hotel: false, mealPlan: false };
  // Flexibilidad de fechas (días ±) para la búsqueda de yates.
  dateFlexOptions = [
    { value: 0, label: 'Fechas exactas' },
    { value: 1, label: '± 1 día' },
    { value: 2, label: '± 2 días' },
    { value: 3, label: '± 3 días' },
    { value: 7, label: '± 7 días' },
    { value: 14, label: '± 14 días' },
  ];
  selectedDateFlex: number = 0;
  validateButtonSearch: boolean;
  componentResultsFirstCharge: boolean = true;
  loadingData: boolean = false;
  routerStorage: any;
   bookingFlowSidebar: any;
   backgroundDisplayContrast: any;
   dateRangeInvalid: boolean = false;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };

   private initialPositioning = false;
private cardHeight = 0;
private closing = false;
  private isSyncing = false;
  private currentLeftDate: Date;
  private currentRightDate: Date;
  private mouseDownTarget: EventTarget | null = null;

  @HostListener('document:mousedown', ['$event'])
  onDocumentMouseDown(event: MouseEvent) {
    this.mouseDownTarget = event.target;
  }

@HostListener('document:click', ['$event'])
onClickOutside(event: MouseEvent) {
  // Si está cerrado o ya estamos cerrando, salir
  if (!this.isCollapsed || this.closing) {
    return;
  }

  const downOnTextField =
    this.mouseDownTarget instanceof HTMLInputElement ||
    this.mouseDownTarget instanceof HTMLTextAreaElement ||
    this.mouseDownTarget instanceof HTMLSelectElement;
  this.mouseDownTarget = null;
  if (downOnTextField) {
    return;
  }

  const clickedTrigger = this.triggerButton?.nativeElement.contains(event.target);
  const clickedSelector = this.cardSelectorRoom?.nativeElement.contains(event.target);

  // Si el clic NO fue en el trigger Y NO fue en el selector
  if (!clickedTrigger && !clickedSelector) {
    this.closing = true;
    this._confirm();
  }
}


  constructor(
    private cdr:ChangeDetectorRef,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private _router: Router,
    private _restService: RestService,
    private ubicacionesService: UbicacionesService,
    private _itineraryService: ItineraryService,
    public vcr: ViewContainerRef,
    public userService: UserService,
    private notificationService: NotificationService,
    private renderer: Renderer2,
    private searchService: ResultsSearchService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<HotelsComponent>
  ) {
    this._maxAdults = Array.from({ length: 10 }, (_, i) => i + 1);
    this._maxChildren = Array.from(Array(11).keys());
    this.minDateDeparture = new Date();
    this.maxDateArrival = new Date();
    this.dpConfig.containerClass = "theme-red";
    this.calendarSync = new DateRangePickerService();
    this.calendarSync.setCategory(true);
  }



openCardSelector(event: Event) {
  this.toggleCard(event);
}

get isParksSearch(): boolean {
  return this.mode === 'PARKS';
}

// Yates y parques usan una sola habitación, sin nacionalidad en pantalla.
get isSimpleSearch(): boolean {
  return this.isBoatSearch || this.isParksSearch;
}

get isBoatSearch(): boolean {
  return this.selectedAccommodationType === 'BOATS';
}

/**
 * Cambia el sub-tipo de alojamiento. Yates no usa nacionalidad ni varias
 * habitaciones, así que se quita la validación y se deja una sola habitación.
 */
selectAccommodationType(type: { key: string; enabled: boolean }): void {
  if (!type.enabled || type.key === this.selectedAccommodationType) {
    return;
  }
  this.selectedAccommodationType = type.key;

  const nationality = this._form.get('nationality');
  nationality.setValidators(this.isSimpleSearch ? null : Validators.required);
  nationality.updateValueAndValidity();

  if (this.isSimpleSearch) {
    const rooms = this._form.get('room') as FormArray;
    while (rooms.length > 1) {
      this._removeRoom(rooms.length - 1);
    }
    this.selectedDateFlex = 0;
  }
  this.setRoomAndPassanger();
}

  ngOnInit(): void {
    if (this.data?.mode === 'PARKS') {
      this.mode = 'PARKS';
    }
    if (this.isParksSearch) {
      this.accommodationTypes = this.parkTypes;
      this.selectedAccommodationType = this.parkTypes[0].key;
    }
    this.routerStorage = setting.apiStorageBooking;
     this.componentResults = this.data && this.data?.component === 'results' ? true : false;
     if(this.componentResults) {
          this.loadingData = true;
     }
     this.clientData();
     this.agencyData();
     this.initForm();
     if (this.isParksSearch) {
       // El diseño de parques no pide nacionalidad ni varias habitaciones.
       const nationalityControl = this._form.get('nationality');
       nationalityControl.clearValidators();
       nationalityControl.updateValueAndValidity();
       this.setRoomAndPassanger();
     }


     this._itineraryService.booleanValidateByStatus$.subscribe((res: any) => {
       this.validateButtonSearch = res;
      });

      //Vuelve a enviar el itinerario activo, cuando se encuentre nuevamente en alojamiento.
      this._itineraryService.validateItineraryByStatus(this.userService.itineraryActive[0]);
          setTimeout(() => {

    });

    this._itineraryService.itinerary$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.cdr.detectChanges();
    });

    // this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

    ngAfterViewInit() {

     setTimeout(() => {
        this.setupAutocompleteStyles();
    });

    this.cdr.detectChanges();
  }


    private setupAutocompleteStyles(): void {
    if (this.auto) {
        this.auto.opened.subscribe(() => {
            setTimeout(() => {
                // Buscar todos los overlays y tomar el último (el más reciente)
                const overlays = document.querySelectorAll('.cdk-overlay-pane');
                const overlay = overlays[overlays.length - 1]; // El último abierto

                if (overlay) {
                    (overlay as HTMLElement).style.minWidth = '30%';
                    (overlay as HTMLElement).style.width = 'fit-content';
                    (overlay as HTMLElement).style.maxWidth = '90vw';
                }
            });
        });
    }

}


  /**
 * Inicializa los datos del cliente desde los datos proporcionados o configuración global
 *
 * Este método extrae y configura la información del cliente desde los datos de entrada
 * y establece el color principal del cliente para personalización de la UI.
 *
 * @returns {void}
 *
 * @dataSource
 * - Primero intenta obtener datos de `this.data.clientSetting`
 * - Si no existe, usa la configuración global del cliente
 *
 * @properties
 * - getClientsSettingAppBooking: Almacena la configuración completa del cliente
 * - bgClientColor: Establece el color principal para estilos UI (#color_main_1)
 *
 * @dependencies
 * - Requiere `this.data` con propiedad `clientSetting`
 * - Requiere estructura de cliente con `clients_setting_global.color_main_1`
 *
 * @example
 * // Configuración típica:
 * this.data = {
 *   clientSetting: {
 *     clients_setting_global: {
 *       color_main_1: '#FF5733'
 *     }
 *   }
 * };
 * this.clientData(); // bgClientColor = '#FF5733'
 */
  clientData(): void {
    if(this.data && this.data?.clientSetting) {
                  this.getClientsSettingAppBooking = this.data?.clientSetting;
                }
    this.bgClientColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
    this.bookingFlowSidebar = JSON.parse(this.getClientsSettingAppBooking.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundDisplayContrast = this.bookingFlowSidebar?.background_color;
  }

  /**
 * Obtiene y establece el ID de la agencia desde localStorage o servicio de usuario
 *
 * Este método intenta recuperar la agencia seleccionada del localStorage y si no existe,
 * utiliza el ID de agencia del servicio de usuario como fallback.
 *
 * @returns {void}
 *
 * @priority
 * 1. ✅ Intenta obtener del localStorage key "selectedAgency"
 * 2. ✅ Si existe, usa agency_id del objeto almacenado
 * 3. ❌ Si no existe, usa this.userService._agencyID
 *
 * @storage
 * - localStorage key: "selectedAgency"
 * - Formato esperado: JSON string con objeto { agency_id: number }
 *
 * @fallback
 * - userService._agencyID: ID de agencia del usuario actual
 *
 * @example
 * // localStorage: '{"agency_id": 123}'
 * this.agencyData(); // agencyId = 123
 *
 * // localStorage: null
 * // userService._agencyID = 456
 * this.agencyData(); // agencyId = 456
 */
  agencyData(): void {
    let agency = JSON.parse(localStorage.getItem("selectedAgency"));

    if(agency) {
      this.agencyId = agency.agency_id;
      this.agencyCountry = agency.country;
    }else{
      this.agencyId = this.userService._agencyID;
    }
  }

  /**
 * Inicializa el formulario principal con controles reactivos y configuraciones
 *
 * Este método configura el formulario principal con validaciones, arrays dinámicos
 * y suscripciones para búsqueda en tiempo real de destinos.
 *
 * @returns {void}
 *
 * @formStructure
 * - destination: Control para destino (requerido + validación personalizada)
 * - arrivalDateDepartureDate: Rango de fechas (requerido + validación)
 * - room: FormArray para habitaciones (dinámico)
 * - serviceType: Tipo de servicio (opcional)
 * - nationality: Nacionalidad (requerido)
 * - qtyProduct: Cantidad de productos (1-7, requerido)
 *
 * @initialization
 * - Establece texto por defecto: "Rooms and passengers"
 * - Añade primera habitación automáticamente (_addRoom())
 * - Inicializa dateRange como string vacío
 *
 * @subscriptions
 * - destination.valueChanges: Búsqueda en tiempo real de ciudades y aeropuertos
 *   - Muestra loading durante búsqueda
 *   - Limpia resultados si input está vacío
 *
 * @validations
 * - CustomValidator.countryValidator: Validación personalizada para país
 * - Validators.required: Campos obligatorios
 * - Validators.min(1)/Validators.max(7): Rango para cantidad de productos
 *
 * @specialActions
 * - nationality: Inicializa con error forzado (setErrors)
 * - componentResults: Si es true, obtiene países (getCountries)
 */
  initForm(): void {
    this.roomsAndPassengers = "Rooms and passengers";
        this._form = this.fb.group({
          destination: [null, Validators.compose([Validators.required, CustomValidator.countryValidator])],
          arrivalDateDepartureDate: ["", Validators.compose([Validators.required, CustomValidator.countryValidator])],
          room: this.fb.array([]),
          serviceType: [],
          nationality: [null, Validators.required],
          qtyProduct: [1, [Validators.required, Validators.min(1), Validators.max(7)]],
        });
        this._addRoom();

        this.dateRange = "";

        this._form.get("destination").valueChanges.subscribe((selectedValue) => {
          let destination = this._form.get('destination').value;
          if (selectedValue) {
            this.isLoading_ = true;
            this.destinationOptions = null;
            this.destinationOptions_ = null;
            this.destinationOptions = this.ubicacionesService.getCitys(selectedValue, 'HOTELS');
            this.destinationOptions_ = this.ubicacionesService.getAirports(selectedValue);

            this.isLoading_ = false;
          } else {
            // Emitir un array vacío si el campo de entrada está vacío o tiene menos de 3 caracteres
            this.destinationOptions = of([]);
            this.destinationOptions_ = of([]);

          }
        });

        this._form.get('nationality').setErrors({error: true});

        if(this.componentResults) {
          this.getCountries(true);
        }
  }

  /**
 * Parchea el formulario principal con valores provenientes de datos existentes
 *
 * Este método complejo reconstruye y popula el formulario basado en datos preexistentes
 * de una categoría específica (actualmente solo categoría 1 - Hoteles). Realiza parsing
 * de fechas, configuración de habitaciones y búsqueda de destinos de forma asíncrona.
 *
 * @returns {void}
 *
 * @prerequisites
 * - Requiere `this.data` con propiedad `category` y `payload`
 * - Solo procesa categoría 1 (Hoteles) actualmente
 *
 * @process
 * 1. Parsing y conversión de fechas (arrivalDate, departureDate)
 * 2. Patch de valores básicos al formulario
 * 3. Configuración dinámica de habitaciones con `getRoomConfiguration`
 * 4. Búsqueda asíncrona de destino para actualizar selección
 * 5. Actualización final de valores del formulario
 *
 * @dataFlow
 * - payload → Parsing fechas → Patch formulario → Config habitaciones → Búsqueda destino → Final patch
 *
 * @asyncOperations
 * - Suscripción a `destinationOptions` para encontrar y actualizar selección de destino
 * - Uso de `take(1)` para completar la suscripción automáticamente
 *
 * @errorHandling
 * - Búsqueda en múltiples fuentes (cities, airports, hotels) para encontrar destino
 * - Fallback sequences si no encuentra en primera opción
 */
formPatchValue(): void {
  if(this.data && this.data?.category) {

    if(!this.data.payload) {
      this.loadingData = false;
      return;
    }

    if(this.data.category !== this.data.payload[0].categoriesId[0]) {
      this.loadingData = false;
      return;
    }

    const payload = this.data.payload[0];


    if(!payload) {
      this.loadingData = false;
      return;
    }
          // Para arrivalDate
          const [arrivalYear, arrivalMonth, arrivalDay] = payload.arrivalDate.split('-');
          let arrivalDate = new Date(Number(arrivalYear), Number(arrivalMonth) - 1, Number(arrivalDay));

          // Para departureDate (mismo método)
          const [departureYear, departureMonth, departureDay] = payload.departureDate.split('-');
          let departureDate = new Date(Number(departureYear), Number(departureMonth) - 1, Number(departureDay));

          if(isNaN(arrivalDate.getTime())){
            arrivalDate = dayjs(payload.arrivalDate).startOf('day').toDate()
          }

          if(isNaN(departureDate.getTime())){
             departureDate = dayjs(payload.departureDate).startOf('day').toDate();
          }

          // Yates usa este mismo formulario: se restaura el modo, el rango de fechas
          // y los pasajeros, que vienen en payload.boats con la forma de una habitación.
          // Parques: se restaura el tipo de parque elegido.
          if (payload.others?.hotelType && this.isParksSearch) {
            this.selectAccommodationType({ key: payload.others.hotelType, enabled: true });
          }
          const isBoatPayload = !!payload.boats;
          if(isBoatPayload) {
            this.selectAccommodationType({ key: 'BOATS', enabled: true });
            this.selectedDateFlex = payload.positiveRange ?? 0;
          }

          // Asignación al formulario
            this._form.patchValue({
                    destination: payload.destination,
                    qtyProduct: this.data.form.qtyProduct,

                  });

          const roomArray = this.getRoomConfiguration(isBoatPayload ? [payload.boats] : payload.others?.hotels?.roomConfiguration);
          // Actualiza el FormArray de habitaciones
           this._form.setControl('room', roomArray);
           this.setRoomAndPassanger();

          this.destinationOptions.pipe(take(1)).subscribe((data: any) => {
              if(data && data.length > 0) {
                let destination = data
                  .flatMap((element: any) => element.cities || [])
                  .find((c: any) => c.city_iata_code === payload.destination);

                    // Si no se encontró en cities, buscar en airports
                  if (!destination) {
                    destination = data
                      .flatMap((element: any) => {
                        // Verificar si tiene airports y es un array de objetos
                        if (
                            element.airports &&
                            Array.isArray(element.airports) &&
                            element.airports.length > 0
                          ) {
                              return element.airports;
                            }
                        return [];
                      })
                      .find((a: any) => a.name === payload.destination ||
                                        a.iata_code === payload.destination);
                    }

                       if(!destination) {
                                destination = data
                                  .flatMap((element: any) => {
                                    if(
                                      element.hotels &&
                                      Array.isArray(element.hotels) &&
                                      element.hotels.length > 0
                                    )
                                      {
                                        return element.hotels;
                                      }
                                  return [];
                                    })
                                    .find((a: any) => a.name === payload.destination ||
                                                      a.iata === payload.destination);
                              }
                if(destination) {
                  this.updateMySelection(destination);
                  this.updateMySelectionNationality(this.data.form.nationality);
                  this.loadingData = false;
                  setTimeout(() => {

                    this._form.patchValue({
                      arrivalDateDepartureDate: {
                        start:  arrivalDate,
                        end: departureDate
                      }
                    })
                  }, 0);
                }
              }
            });

            // this._form.patchValue({
            //   destination: this.data.form.destination
            // })

            this._form.get('destination')?.setValue(this.data.form.destination ?? null);



  }
}

/**
 * Convierte una configuración de habitaciones en un FormArray reactivo con validaciones
 *
 * Este método transforma un objeto de configuración de habitaciones en una estructura
 * de FormArray con FormGroups para cada habitación, incluyendo validaciones completas
 * para adultos, niños y edades de los niños.
 *
 * @param {any} roomConfiguration - Objeto con configuración de habitaciones a convertir
 * @returns {FormArray} - FormArray reactivo listo para usar en formulario
 *
 * @structure
 * FormArray de habitaciones → FormGroup por habitación con:
 * - qtyAdults: Cantidad de adultos (number, requerido)
 * - qtyChilds: Cantidad de niños (number, basado en children array)
 * - childsage: FormArray de niños → FormGroup por niño con:
 *   - age: Edad del niño (0-17, requerido, solo números)
 *   - id: Identificador único (index-based)
 *
 * @validations
 * - qtyAdults: Validators.required
 * - age:
 *   - Validators.required
 *   - CustomValidator.soloNumerosValidator (solo números)
 *   - Validators.min(0) (edad mínima 0)
 *   - Validators.max(17) (edad máxima 17)
 *
 * @transformation
 * - Convierte roomConfiguration array → FormArray
 * - Mapea cada room object → FormGroup
 * - Convierte children array → FormArray de edades
 *
 * @example
 * // Input:
 * [{
 *   adults: 2,
 *   children: [5, 8]
 * }]
 *
 * // Output:
 * FormArray([
 *   FormGroup({
 *     qtyAdults: 2,
 *     qtyChilds: 2,
 *     childsage: FormArray([
 *       FormGroup({ age: 5, id: 0 }),
 *       FormGroup({ age: 8, id: 1 })
 *     ])
 *   })
 * ])
 */
getRoomConfiguration(roomConfiguration: any): FormArray {
  const roomFormArray = this.fb.array([]);

  roomConfiguration.forEach((room: any) => {
    const childsAgesArray = this.fb.array([]); // Crea un FormArray vacío

    if (room.children && Array.isArray(room.children)) {
      room.children.forEach((age, index) => {
        childsAgesArray.push(
          this.fb.group({
            age: [
              age,
              Validators.compose([
                Validators.required,
                CustomValidator.soloNumerosValidator,
                Validators.min(0),
                Validators.max(17)
              ])
            ],
            id: [index]
          })
        );
      });
    }

    roomFormArray.push(
      this.fb.group({
        qtyAdults: [Number(room.adults) || 1, Validators.required],
        qtyChilds: [childsAgesArray.length || 0],
        childsage: childsAgesArray // Asigna directamente el FormArray
      })
    );
  });

  return roomFormArray;
}

/**
 * Ajusta la posición de un elemento para asegurar que permanezca dentro de los límites del viewport
 *
 * Versión corregida que utiliza viewport del navegador en lugar de la pantalla completa
 */
adjustElementPosition(pickerElement: HTMLElement, inputRect: DOMRect): void {
  const pickerRect = pickerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Guardar la posición original para cálculo de ajustes
  const originalTop = parseFloat(pickerElement.style.top) || pickerRect.top;
  const originalLeft = parseFloat(pickerElement.style.left) || pickerRect.left;

  // Ajuste vertical - si no cabe abajo, mostramos arriba del input
  if (pickerRect.bottom > viewportHeight) {
    const newTop = inputRect.top + window.scrollY - pickerRect.height;
    pickerElement.style.top = `${Math.max(10, newTop)}px`; // Mínimo 10px del borde superior
  }

  // Ajuste horizontal - si no cabe a la derecha, alineamos a la izquierda
  if (pickerRect.right > viewportWidth) {
    const newLeft = Math.max(10, viewportWidth - pickerRect.width - 10);
    pickerElement.style.left = `${newLeft}px`;
  }

  // Ajuste adicional: si se sale por arriba después del ajuste
  const finalRect = pickerElement.getBoundingClientRect();
  if (finalRect.top < 10) {
    pickerElement.style.top = '10px';
  }

  // Ajuste adicional: si se sale por la izquierda
  if (finalRect.left < 10) {
    pickerElement.style.left = '10px';
  }
}

/**
 * Abre y posiciona el date picker correctamente en el viewport
 * Versión mejorada con manejo de viewport del navegador
 */
openDatePickerSimple(): void {
  if (this.picker) {
    this.picker.open();

    const mdPicker = document.querySelector('.md-drppicker');
    if (mdPicker) {
      this.calendarSync.setup(mdPicker as HTMLElement);
    }
  }
}


onDateRangeChange(): void {
    // Ver si dateRange tiene startDate y endDate
    if (this.startDate && !this.endDate) {
        // Si tiene startDate y NO tiene endDate (aún no completó el rango)
            this.calendarSync.setStartDate(this.startDate ? this.startDate : this.dateRange.start);
        }
        // Si tiene startDate y endDate (rango completo)
    if (this.startDate && this.endDate) {
            this.calendarSync.clearStartDate();
        }
    }


/**
 * Expande y posiciona estratégicamente el contenedor de configuración de pasajeros
 *
 * Este método ajusta el posicionamiento del contenedor de configuración de pasajeros
 * para que aparezca fijo en relación al elemento contenedor, con ajustes automáticos
 * para evitar que se salga de los límites del viewport.
 *
 * @returns {void}
 *
 * @prerequisites
 * - Solo ejecuta si `this.componentResults` es true
 * - Requiere que existan los elementos DOM correspondientes
 *
 * @process
 * 1. Localiza elementos DOM del contenedor y configuración
 * 2. Calcula posición basada en el contenedor padre
 * 3. Aplica estilos de posicionamiento fixed preciso
 * 4. Realiza ajustes de boundaries con `adjustElementPosition`
 *
 * @positioning
 * - Posición: fixed (respecto al viewport)
 * - Top: bottom del contenedor + scroll vertical
 * - Left: left del contenedor + scroll horizontal
 * - Z-index: 9999 (máxima prioridad visual)
 *
 * @elements
 * - .config-passenger: Elemento a posicionar
 * - .element-config-passenger: Elemento de referencia para posicionamiento
 *
 * @uses adjustElementPosition() - Para ajustes de boundaries del viewport
 */
expandedConfigPassenger(): void {

  if(this.componentResults) {
    const configPassengerElement = document.querySelector('.config-passenger') as HTMLElement;
    const configPassengerContainer = document.querySelector('.element-config-passenger') as HTMLElement;

    if(configPassengerElement && configPassengerContainer) {

      // Calculamos la posición del input en el viewport
        const inputRect = configPassengerContainer.getBoundingClientRect();

       // Ajustamos la posición del picker relativa al input
        configPassengerElement.style.position = 'fixed';


        // configPassengerElement.style.top = `${inputRect.bottom + window.scrollY}px`;
        // configPassengerElement.style.left = `${inputRect.left + window.scrollX}px`;
        configPassengerElement.style.transform = 'none';
        configPassengerElement.style.maxHeight = 'none';
        configPassengerElement.style.overflow = 'visible';
        configPassengerElement.style.zIndex = '9999';

        configPassengerContainer.getBoundingClientRect();

          // Verificamos si el picker se sale de la pantalla y ajustamos
        // this.adjustElementPosition(configPassengerElement, inputRect);
    }

  }

}



/**
 * Obtiene los controles de un FormArray dentro de un FormGroup
 *
 * Este método utility facilita el acceso a los controles individuales de un FormArray
 * contenido dentro de un FormGroup, útil para iterar en templates con *ngFor.
 *
 * @param {FormGroup} form - FormGroup que contiene el FormArray
 * @param {string} key - Nombre de la clave del FormArray dentro del FormGroup
 * @returns {AbstractControl[]} - Array de controles del FormArray
 *
 * @typeSafety
 * - Realiza casting explícito a FormArray mediante: (<FormArray>form.get(key))
 * - Retorna la propiedad .controls del FormArray
 *
 * @example
 * // En template:
 * <div *ngFor="let room of formRoom(myForm, 'rooms')">
 *   <!-- Controles individuales de cada habitación -->
 * </div>
 *
 * @usage
 * Simplifica el acceso a arrays de formularios reactivos en templates Angular
 */
  formRoom(form: FormGroup, key: string) {
    return (<FormArray>form.get(key)).controls;
  }

  /**
 * Verifica si existe algún error de edad en los niños de todas las habitaciones
 *
 * Este método recorre todos los controles de edad de niños en un FormArray
 * y determina si al menos uno tiene errores de validación relacionados con la edad.
 *
 * @param {FormGroup} form - FormGroup que contiene el FormArray de habitaciones
 * @param {string} key - Clave del FormArray que contiene las edades de niños
 * @returns {boolean} - true si existe al menos un error de edad, false otherwise
 *
 * @validationsChecked
 * - invalidsoloNumeros: El valor debe contener solo números
 * - min: La edad mínima permitida (generalmente 0)
 * - max: La edad máxima permitida (generalmente 17)
 * - required: El campo es obligatorio
 *
 * @implementation
 * 1. Obtiene el FormArray mediante casting
 * 2. Utiliza Array.some() para encontrar el primer error
 * 3. Verifica múltiples tipos de error con operador lógico OR
 *
 * @usage
 * Útil para mostrar mensajes de error generales en lugar de errores individuales por niño
 */
  hasChildAgeError(form: FormGroup, key: string): boolean {
  const ageArray = form.get(key) as FormArray;
  return ageArray.controls.some(ageControl => {
    const control = ageControl.get('age');
    return control?.errors &&
           (control.hasError('invalidsoloNumeros') ||
            control.hasError('min') ||
            control.hasError('max') ||
            control.hasError('required'));
  });
}

/**
 * Agrega una nueva habitación al formulario de reserva
 *
 * Este método agrega un nuevo FormGroup representando una habitación al FormArray
 * de habitaciones, con valores por defecto y validaciones apropiadas.
 *
 * @returns {void}
 *
 * @defaultValues
 * - qtyAdults: 1 adulto (valor mínimo requerido)
 * - qtyChilds: 0 niños (sin niños por defecto)
 * - childsage: FormArray vacío para edades de niños
 *
 * @validations
 * - qtyAdults: Validators.required + Validators.min(1)
 * - qtyChilds: Validators.required
 *
 * @sideEffects
 * - Actualiza automáticamente qtyProduct con la cantidad total de habitaciones
 * - Si es componente de resultados, ejecuta updateCardPosition() para ajustes UI
 *
 * @businessLogic
 * - Si no hay habitaciones (length < 1), establece qtyProduct en 0
 * - Si hay habitaciones, establece qtyProduct igual al número de habitaciones
 *
 * @uiIntegration
 * - updateCardPosition(): Ajusta la posición de elementos UI en componente de resultados
 */
  _addRoom(event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const room = this._form.get("room") as FormArray;
    room.push(
      this.fb.group({
        qtyAdults: [1, [Validators.required, Validators.min(1)]],
        qtyChilds: [0, Validators.required],
        childsage: this.fb.array([]),
      })
    );
    if (room.length < 1 || !room.length) {
      this._form.get("qtyProduct").setValue(0);
    } else {
      this._form.get("qtyProduct").setValue(room.length);
    }

    if(this.componentResults) {
      this.updateCardPosition();
    }
  }

  /**
 * Elimina una habitación específica del formulario de reserva
 *
 * Este método remueve un FormGroup (habitación) del FormArray en el índice especificado
 * y actualiza las dependencias del formulario.
 *
 * @param {number} index - Índice de la habitación a eliminar (0-based)
 * @returns {void}
 *
 * @operations
 * 1. Obtiene referencia al FormArray de habitaciones
 * 2. Elimina la habitación en el índice especificado usando removeAt()
 * 3. Actualiza qtyProduct con la nueva cantidad de habitaciones
 *
 * @sideEffects
 * - Actualiza qtyProduct reflejando el nuevo count de habitaciones
 * - Si es componente de resultados, ejecuta updateCardPosition() para ajustes UI
 *
 * @errorHandling
 * - removeAt() maneja automáticamente índices inválidos (no arroja error)
 * - Angular Forms maneja la actualización del estado de validación
 *
 * @uiIntegration
 * - updateCardPosition(): Recalcula posiciones UI después de remover elemento
 */
  _removeRoom(index: number, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const room = this._form.get("room") as FormArray;
    room.removeAt(index);
    this._form.get("qtyProduct").setValue(room.length);
        if(this.componentResults) {
      this.updateCardPosition();
    }
  }

/**
 * Actualiza dinámicamente la posición vertical del card selector basado en la cantidad de habitaciones
 *
 * Este método calcula y aplica una transformación CSS para desplazar verticalmente el elemento
 * card selector en función del número de habitaciones seleccionadas, creando un efecto visual
 * de desplazamiento proporcional.
 *
 * @returns {void}
 *
 * @calculations
 * - qtyProduct: Obtiene la cantidad actual de habitaciones del formulario
 * - offset: Calcula el desplazamiento en píxeles (71.5px por habitación adicional)
 *
 * @formula
 * - offset = (qtyProduct - 1) * 71.5
 * - Ejemplo: 3 habitaciones → (3-1)*71.5 = 143px de desplazamiento
 *
 * @animation
 * - Aplica transformación CSS: translateY(-${offset}px)
 * - Agrega transición suave: transform 0.3s ease
 *
 * @prerequisites
 * - Requiere que this.cardSelectorRoom esté inicializado (ViewChild)
 * - Requiere que el formulario tenga control qtyProduct
 *
 * @usage
 * Llamado automáticamente después de agregar/remover habitaciones
 */
updateCardPosition() {
  if (this.cardSelectorRoom) {
    const qtyProduct = this._form.get("qtyProduct").value;
    const offset = (qtyProduct - 1) * 71.5; // 80px por habitación

    this.renderer.setStyle(
      this.cardSelectorRoom.nativeElement,
      'transform',
      `translateY(-${offset}px)`
    );

    this.renderer.setStyle(
      this.cardSelectorRoom.nativeElement,
      'transition',
      'transform 0.3s ease'
    );
  }
}

/**
 * Maneja el evento de selección de fecha de inicio y actualiza el estado interno
 *
 * Este método captura la fecha de inicio seleccionada y la almacena para validaciones
 * posteriores con la fecha de fin. También podría establecer límites de fecha máxima.
 *
 * @param {any} $event - Objeto evento del date picker con información de la fecha seleccionada
 * @returns {void}
 *
 * @storage
 * - Almacena la fecha de inicio en this.startDate para uso en validaciones
 *
 * @potentialFeatures
 * - Podría establecer this.maxDate para limitar selección de fecha fin
 * - Comentado: maxDate = fecha inicio + 1 mes
 *
 * @note
 * - Actualmente la funcionalidad de maxDate está comentada
 * - El método principalmente sirve para almacenar el estado
 */
  startDateClicked($event) {
    this.endDate = null;
    this.startDate = $event;
    this.onDateRangeChange();
  }

  /**
 * Valida y procesa la fecha de fin seleccionada en relación con la fecha de inicio
 *
 * Este método realiza validaciones robustas para asegurar que la fecha de fin sea
 * posterior a la fecha de inicio y proporciona retroalimentación visual al usuario
 * en caso de error, reiniciando el selector de fechas.
 *
 * @param {any} $event - Objeto evento del date picker con información de la fecha final
 * @returns {void}
 *
 * @validations
 * 1. ✅ Fecha válida (isValid)
 * 2. ✅ No igual a fecha inicio (isSame)
 * 3. ✅ Posterior a fecha inicio (isBefore)
 *
 * @errorHandling
 * - Muestra toast de advertencia con mensaje descriptivo
 * - Limpia el campo del formulario
 * - Reinicia el date picker después de 100ms
 * - Reabre el calendario para nueva selección
 *
 * @successHandling
 * - Almacena el rango válido en this.dateRange
 * - Usa dayjs para consistencia en manejo de fechas
 *
 * @uxConsiderations
 * - setTimeout(100): Da tiempo para que el usuario vea el mensaje de error
 * - picker.clear() + picker.open(): Flujo intuitivo de corrección
 */
  endDateClicked($event: any): void {
    // Convertimos a Day.js las fechas para garantizar consistencia
    const selectedStartDate = dayjs(this.startDate.startDate.$d).startOf('day');
    const selectedEndDate = dayjs($event.endDate.$d).startOf('day'); // Normaliza al inicio del día
    this.endDate = $event;

    // Validar si la fecha de fin es inválida, igual o anterior a la fecha de inicio
    if (!selectedEndDate.isValid() || selectedEndDate.isSame(selectedStartDate) || selectedEndDate.isBefore(selectedStartDate)) {

      this.notificationService.warning('Debe elegir mínimo un día de diferencia con el día de inicio');


      this._form.get('arrivalDateDepartureDate')?.setValue(null); // Limpia el campo en el formulario

      setTimeout(() => {
        this.picker.clear(); // Limpia cualquier selección previa del datePicker
        this.picker.open(); // Reabre el calendario para seleccionar una nueva fecha
        // Resetea el rango de fechas y el formulario
      }, 100);
    } else {
      this.onDateRangeChange();
      this.dateRange = { start: selectedStartDate, end: selectedEndDate };
    }
  }

  /**
 * Procesa el envío del formulario de búsqueda de hoteles con validaciones y manejo completo
 *
 * Este método complejo maneja todo el flujo de envío del formulario, incluyendo validaciones,
 * construcción del payload, llamadas al API, manejo de respuestas y redireccionamiento.
 *
 * @param {FormGroup} form - Formulario reactivo con datos de búsqueda
 * @param {Event} [event] - Evento opcional del formulario para preventDefault()
 * @param {Object} [dummy] - Payload opcional para testing o casos especiales
 * @returns {void}
 *
 * @flow
 * 1. ✅ Validación de destino seleccionado
 * 2. ✅ Prevención de default del evento
 * 3. ✅ Construcción del payload con searchPayload()
 * 4. ✅ Persistencia en localStorage
 * 5. ✅ Manejo diferenciado componentResults vs normal flow
 * 6. ✅ Llamada API y manejo de respuestas
 * 7. ✅ Redireccionamiento o manejo de errores
 *
 * @scenarios
 * - componentResults = true: Cierra dialog y retorna payload
 * - componentResults = false: Flujo completo con llamada API
 *
 * @apiHandling
 * - Success: Procesa resultados, emite eventos, navega a /results
 * - Empty Results: Muestra modal de "no resultados"
 * - Error: Muestra modal de error con reintento opcional
 *
 * @storage
 * - localStorage: Almacena form values y payload para persistencia
 * - Elimina payload previo para evitar conflicts
 *
 * @errorRecovery
 * - Modal de error permite reintentar o volver al home
 * - unsubscribe() para evitar memory leaks
 */
  _onSubmit(form: FormGroup, event?: Event, dummy?: Object) {

    if (!form.valid) {
      // Marcar solo campos que tienen errores
      Object.keys(form.controls).forEach(key => {
        const control = form.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });

      return;
    }

    this.dateRangeInvalid =   !this.dateRange &&
                                !this.dateRange.start &&
                                !this.dateRange.end;
    if(this.dateRangeInvalid) {
      return;
    }

    this.dateRangeInvalid = false;
    const _payload = [];
    let nationality = this.selectNationality;
    let country = this.country;
    if (this.selectedDestiny !== undefined && this.selectedDestiny !== null) {
      if (event) {
        event.preventDefault();
      }
      const category = this.isParksSearch ? "PARKS" : (this.isBoatSearch ? "BOATS" : "HOTELS");
      let payload;
      if (this.isParksSearch) {
        payload = searchPayload(category, this.dateRange, form, this.selectedDestiny, '', { hotelType: this.selectedAccommodationType }, null, nationality || 'US', this.agencyId, country);
      } else if (this.isBoatSearch) {
        payload = searchPayload(category, this.dateRange, form, this.selectedDestiny, '', { dateFlex: this.selectedDateFlex }, null, null, this.agencyId);
      } else {
        payload = searchPayload(category, this.dateRange, form, this.selectedDestiny, '','', null, nationality, this.agencyId, country, this.hotel_id);
      }

      if (!this.isBoatSearch && !this.isParksSearch) {
        payload.providersId = this.userService._providerId;
        payload.agencyCountry = this.agencyCountry;
      }

      localStorage.setItem("form", JSON.stringify(form.value));
      if (localStorage.getItem("payload")) {
        localStorage.removeItem("payload");
      }

      _payload[0] = payload;
      localStorage.setItem("payload", JSON.stringify(_payload));

      if(this.componentResults) {
        this.dialogRef.close(payload);
        localStorage.setItem('origin', category);
    } else {

      this._emitLoading(true);
      this._restService.doPost("app", "search", dummy || payload).subscribe(
        (response: any) => {
          if (response !== null && response.results && Array.isArray(response.results) && response.results.length > 0) {

            const payloadArray = (this.isBoatSearch || this.isParksSearch)
              ? [payload]
              : [searchPayload("HOTELS", this.dateRange, form, this.selectedDestiny,'', '',null, this.selectNationality, this.agencyId, country)];
            this.payload.emit(payloadArray);
            if (!this.isBoatSearch) {
              this._colocarSearchIdEnlosHoteles(response);
            }
            this._setArrivalAndDepartureDate(response, form);
            this._handleResponse(response, category, form);
            this._emitOrigin(category);
            this._emitLoading(false);
            this._router.navigate(["/results"]);


          } else {
            setTimeout(() => {
            this._emitLoading(false);
              const initialState: ModalOptions = {
                initialState: {
                  message: '',
                  confirmText: 'Cerrar',
                  cancelText: 'Volver a intentar',
                  extraText: 'Cotización offline',
                  showCancelButton: true,
                  showExtraButton: true,
                  size: 'sm',
                }
              };
              const modalOptions = Object.assign({}, initialState, this.config);
              this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);

              const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
                if (!result) {
                  this._onSubmit(form, event);
                } else {
                  this.bsModalRef.hide();
                  this._router.navigate(["/home"]);
                }
                confirmSubscription.unsubscribe();
              });

              const extraSubscription = this.bsModalRef.content.extraResult.subscribe(() => {
                extraSubscription.unsubscribe();
                this.openOfflineQuoteModal();
              });
            }, 3000);


          }
        },
        (error) => {
          setTimeout(() => {
            this._emitLoading(false);
              const initialState: ModalOptions = {
                initialState: {
                  message: 'Ocurrió un error al intentar encontrar productos. Inténtalo de nuevo'
                }
              };

              this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);

              const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
                  if(result) {
                    if (result) {
                      this._onSubmit(form, event);
                    } else {
                      this.bsModalRef.hide();
                      this._router.navigate(["/home"]);
                    }
                  } else {

                  }
                  confirmSubscription.unsubscribe();
                });
              }, 3000);

          }
        );
      }
    } else {
      this._form.get("destination").setErrors({ invalidDestination: true });
    }
  }

  /**
 * Emite el origen de la búsqueda a través de un EventEmitter
 *
 * Este método permite comunicar el tipo de origen (categoría) de la búsqueda
 * al componente padre mediante un evento emitido.
 *
 * @param {any} origin - Origen/categoría de la búsqueda (ej: "HOTELS", "FLIGHTS")
 * @returns {void}
 *
 * @emits
 * - origin: Evento que contiene el tipo de origen de la búsqueda
 *
 * @usage
 * Utilizado para informar al componente padre sobre el contexto de la búsqueda
 * realizada, permitiendo diferentes comportamientos basados en la categoría
 */
  _emitOrigin(origin: any) {
    this.origin.emit(origin);
  }

  /**
 * Asigna el searchId de la respuesta a cada habitación en los resultados de hoteles
 *
 * Este método procesa la respuesta de búsqueda y propaga el searchId a nivel de
 * habitación para facilitar el tracking y futuras operaciones con cada habitación.
 *
 * @param {any} response - Respuesta completa del servicio de búsqueda
 * @returns {void}
 *
 * @process
 * 1. Verifica que la respuesta no sea nonAvailable
 * 2. Itera sobre cada habitación en additionalInfo.rooms
 * 3. Asigna el searchId de la respuesta a cada habitación
 *
 * @structure
 * - response.searchId: ID único de la búsqueda
 * - response.results[0]?.additionalInfo.rooms: Array de habitaciones
 *
 * @purpose
 * - Facilitar operaciones individuales por habitación usando el searchId
 * - Mantener consistencia en el tracking de la búsqueda
 */
  _colocarSearchIdEnlosHoteles(response: any) {
    if(!response.results.nonAvailable){
      response.results[0]?.additionalInfo.rooms.forEach((obj) => {
        obj.room.searchId = response.searchId;
      });
    }
  }


  /**
 * Establece las fechas de llegada y salida en los resultados de la búsqueda
 *
 * Este método formatea y asigna las fechas del rango seleccionado al objeto
 * de resultados, normalizándolas al formato ISO 8601 (YYYY-MM-DD).
 *
 * @param {any} response - Objeto de respuesta donde se asignarán las fechas
 * @param {FormGroup} form - Formulario (no utilizado actualmente en este método)
 * @returns {void}
 *
 * @formatting
 * - Usa moment.js para parsing y formateo consistente
 * - Formato de salida: "YYYY-MM-DD" (ISO 8601)
 *
 * @source
 * - this.dateRange.start.$d: Fecha de inicio del rango
 * - this.dateRange.end.$d: Fecha de fin del rango
 *
 * @processing
 * - Convierte Date object a string
 * - Split por coma para obtener solo la parte de la fecha
 * - Formatea a YYYY-MM-DD
 */
  _setArrivalAndDepartureDate(response: any, form) {
      response.results.dateIni = moment(this.dateRange.start.$d.toString().split(",")[0]).format("YYYY-MM-DD");
      response.results.dateEnd = moment(this.dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD");

  }

  /**
 * Procesa y normaliza la respuesta de búsqueda para su uso en la aplicación
 *
 * Este método centraliza el manejo de la respuesta del API, agregando metadatos,
 * manejando casos edge de no resultados, y emitiendo los resultados normalizados.
 *
 * @param {any} response - Respuesta cruda del servicio de búsqueda
 * @param {string} categoryName - Nombre de la categoría de búsqueda
 * @param {FormGroup} form - Formulario asociado a la búsqueda
 * @returns {void}
 *
 * @processing
 * 1. ✅ Verifica que response y response.results no sean null
 * 2. ✅ Agrega metadatos: categoryName, arrivalDate, destination
 * 3. ✅ Maneja caso de array vacío con mensaje descriptivo
 * 4. ✅ Adjunta el formulario completo a los resultados
 * 5. ✅ Emite resultados normalizados mediante EventEmitter
 *
 * @errorHandling
 * - Try-Catch: Maneja excepciones inesperadas durante el procesamiento
 * - Fallback: Restablece page a 1 en caso de error
 *
 * @emits
 * - results: Array de resultados procesados y normalizados
 */
  _handleResponse(response: any, categoryName: string, form: FormGroup) {

    if (response && response.results != null) {
      try {
        this._resultsQuery = response.results;
        delete this._resultsQuery?.dateEnd;
        delete this._resultsQuery?.dateIni;
        this._resultsQuery.categoryName = categoryName;
        this._resultsQuery.arrivalDate = moment(this.dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD"); // form.value['arrivalDate'];
        this._resultsQuery.destination = this._longDestination;

        if (!response.results.length) {
          this._resultsQuery.noResultMessage = "No results found for the search";
        }
        // se anexa el formulario actual
        this._resultsQuery.form = form;
        const arrayResults = [this._resultsQuery];
        this.results.emit(arrayResults);
      } catch (e) {
        this._resultsQuery = [];
        this._restService.page = 1;
      }
    } else {
      this._resultsQuery = [];
      this._resultsQuery.noResultMessage = "No results found for the search";
      this.results.emit(this._resultsQuery);
    }
  }

  /**
   * Abre el modal de cotización offline cuando el usuario clickea
   * "Solicitud offline" en el modal de no resultados de hoteles.
   *
   * Replica el patrón usado en `header.component.ts > openModalFormOffline`:
   * se abre vía `MatDialog` con `disableClose: true` y se le pasa la
   * configuración de cliente para que el formulario respete los estilos
   * del cliente.
   */
  openOfflineQuoteModal(): void {
    this.dialog.open(FormOfflineComponent, {
      disableClose: true,
      width: '80%',
      maxHeight: '90vh',
      data: {
        clientSetting: this.getClientsSettingAppBooking,
        prefill: this.buildOfflinePrefill()
      }
    });
  }

  /**
   * Construye el payload de prefill para el FormOfflineComponent a partir
   * del estado actual del formulario de búsqueda de hoteles.
   *
   * Solo incluye campos que existen en ambos formularios (search-box → form-offline).
   * Los campos propios del form-offline (hotelsName, zone, meals, star, etc.)
   * quedan vacíos para que el usuario los complete.
   *
   * @returns Objeto con los campos pre-rellenables, o {} si no hay datos suficientes.
   */
  buildOfflinePrefill(): any {
    const formValue = this._form?.value;
    const rooms: any[] = Array.isArray(formValue?.room) ? formValue.room : [];

    // destination: "city, country" cuando ambos están disponibles
    let destination: string | null = null;
    if (this._longDestination) {
      destination = this.country_name
        ? `${this._longDestination}, ${this.country_name}`
        : this._longDestination;
    }

    // Fechas: convertir dayjs → Date nativo. Si no hay rango, null.
    let arrivalDepartureDate: { start: Date; end: Date } | null = null;
    const start = this.dateRange?.start;
    const end = this.dateRange?.end;
    if (start && end && typeof start.toDate === 'function' && typeof end.toDate === 'function') {
      arrivalDepartureDate = { start: start.toDate(), end: end.toDate() };
    }

    // Huespedes: sumar a través de todas las habitaciones
    let totalAdults = 0;
    let totalChilds = 0;
    const ages: number[] = [];
    rooms.forEach((room: any) => {
      totalAdults += Number(room?.qtyAdults) || 0;
      totalChilds += Number(room?.qtyChilds) || 0;
      const childsage = Array.isArray(room?.childsage) ? room.childsage : [];
      childsage.forEach((child: any) => {
        const age = Number(child?.age);
        if (!isNaN(age)) {
          ages.push(age);
        }
      });
    });
    const age_childs = ages.length > 0 ? ages.join(', ') : null;

    return {
      destination,
      arrivalDepartureDate,
      nationality: this.selectNationalityName || null,
      adults: totalAdults,
      childs: totalChilds,
      age_childs,
      qty_rooms: Number(formValue?.qtyProduct) || null,
    };
  }

  /**
 * Confirma la selección y actualiza el estado de la UI
 *
 * Este método maneja la acción de confirmación, colapsando la UI de selección
 * y activando las validaciones, además de actualizar la visualización de rooms/passengers.
 *
 * @returns {void}
 *
 * @stateChanges
 * - isCollapsed: false → Muestra el contenido confirmado
 * - validate: true → Activa el estado de validación
 *
 * @actions
 * - setRoomAndPassanger(): Actualiza la visualización de la selección
 *
 * @usage
 * Llamado cuando el usuario confirma su selección de habitaciones/pasajeros
 */
_confirm(event?: Event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  this.isCollapsed = false;
  this.validate = true;
  this.setRoomAndPassanger();

  // Resetear flag después de cerrar
  setTimeout(() => {
    this.closing = false;
  }, 100);
}


  /**
 * Abre el modal de selección y actualiza el estado de la UI
 *
 * Este método prepara la UI para mostrar el modal de selección de habitaciones/pasajeros,
 * colapsando el contenido principal y emitindo el estado del modal.
 *
 * @returns {void}
 *
 * @stateChanges
 * - isCollapsed: true → Expande el modal de selección
 * - validate: false → Desactiva validaciones durante la selección
 * - _close: false → Indica que el modal está abierto
 *
 * @emits
 * - modal: "true" → Informa que el modal debe abrirse (con setTimeout para asegurar render)
 *
 * @timing
 * - setTimeout(100): Da tiempo para que la UI se actualice antes de abrir el modal
 */
_openModal() {
  this.applyImageFilter();
  this.isCollapsed = true;
  this.validate = false;
  this._close = false;
  this.closing = false; // Resetear flag al abrir
  setTimeout(() => {
    this.modal.emit("true");
  }, 100);
}

  /**
 * Maneja el evento de salida del modal o área de selección
 *
 * Este método emite un evento indicando que el modal debería cerrarse
 * o que el cursor ha salido del área de selección.
 *
 * @returns {void}
 *
 * @emits
 * - modal: "false" → Informa que el modal debe cerrarse
 *
 * @usage
 * Typicalmente usado con eventos mouseleave o click outside
 */
  _over() {
    this.modal.emit("false");
  }

  /**
 * Maneja el evento de clic fuera del área de selección
 *
 * Este método se ejecuta cuando se detecta un clic fuera del área
 * de selección de habitaciones/pasajeros, confirmando la selección actual.
 *
 * @param {any} event - Objeto evento del clic
 * @returns {void}
 *
 * @actions
 * - setRoomAndPassanger(): Actualiza la visualización con la selección actual
 *
 * @usage
 * Mejora la UX al confirmar automáticamente al hacer clic fuera del modal
 */
  clickOutside(event: any) {
    this.setRoomAndPassanger();
  }

  /**
 * Genera la distribución de habitaciones para una reserva específica
 *
 * Este método transforma la estructura del formulario de habitaciones en un array
 * de objetos RoomConfigurationItem listos para ser usados en el payload de reserva.
 *
 * @param {any} [form] - Formulario opcional que contiene los datos de las habitaciones
 * @param {any} [item] - Item opcional que contiene información específica de la habitación (rate, room codes, etc.)
 * @returns {RoomConfigurationItem[]} - Array de objetos con la distribución de adultos y niños por habitación
 *
 * @structure RoomConfigurationItem
 * - adults: number - Cantidad de adultos en la habitación
 * - children: number[] - Array de edades de los niños
 * - boardNameCode: string - Código del plan de alimentación
 * - condition: string - Clase de tarifa o condición
 * - roomCode: string - Código de la habitación
 * - roomId: string - ID de la habitación
 * - bookingCode: string - Código de booking
 *
 * @process
 * 1. Itera sobre cada habitación del formulario
 * 2. Crea un objeto RoomConfigurationItem por habitación
 * 3. Extrae y cuenta adultos y edades de niños
 * 4. Preserva metadatos del item (códigos, condiciones)
 *
 * @example
 * // Input: form con 2 habitaciones, item con datos de tarifa
 * // Output: [{ adults: 2, children: [5, 8], boardNameCode: 'AI', ... }]
 */
  _getRoomDist(form?: any, item?: any) {
    const roomDist = [];
    const rooms = form.value.room;
    for (let i = 0; i < rooms.length; i++) {
      const people = [];
      const dist: RoomConfigurationItem = {
        adults: 0,
        children: [],
        boardNameCode: item.boardNameCode,
        condition:  item.rateClassId,
        roomCode:item.roomCode,
        roomId:item.roomId,
        bookingCode:item.bookingCode,
        extras: []
      };
      const adults = rooms[i].qtyAdults;
      const children = rooms[i].childsage;
      for (let j = 0; j < children.length; j++) {
        people.push(children[j].age);
      }
      dist.adults = adults;
      dist.children = people;
      roomDist.push(dist);
    }
    return roomDist;
  }


  /**
 * Calcula la cantidad total de adultos o niños across todas las habitaciones
 *
 * Este método utility suma la cantidad total de personas (adultos o niños)
 * a partir de un array de habitaciones, permitiendo obtener totals generales.
 *
 * @param {string} key - Tipo de cantidad a calcular: "qtyAdults" o "qtyChilds"
 * @param {Array<any>} room - Array de objetos de habitaciones con propiedades qtyAdults/qtyChilds
 * @returns {number} - Cantidad total de adultos o niños
 *
 * @logic
 * - Si key === "qtyAdults": Suma todas las propiedades qtyAdults
 * - Si key === "qtyChilds": Suma todas las propiedades qtyChilds
 *
 * @transformation
 * - Usa +element para convertir strings a números
 * - Usa map().forEach() para iterar y sumar eficientemente
 *
 * @example
 * // Habitaciones: [{qtyAdults: 2, qtyChilds: 1}, {qtyAdults: 1, qtyChilds: 2}]
 * _getAdultsChildrenQty("qtyAdults", rooms) → 3
 * _getAdultsChildrenQty("qtyChilds", rooms) → 3
 */
  _getAdultsChildrenQty(key: string, room: Array<any>) {
    let qty = 0;
    key === "qtyAdults"
      ? room.map((obj) => obj.qtyAdults).forEach((element) => (qty += +element))
      : room.map((obj) => obj.qtyChilds).forEach((element) => (qty += +element));
    return qty;
  }


  /**
 * Gestiona dinámicamente la adición/remoción de controles de niños en una habitación
 *
 * Este método ajusta el FormArray de niños basado en la cantidad especificada en qtyChilds,
 * agregando o removiendo controles de edad según sea necesario con validaciones apropiadas.
 *
 * @param {FormGroup} item - FormGroup de la habitación que contiene el control qtyChilds y el FormArray childsage
 * @returns {void}
 *
 * @process
 * 1. Captura el valor actual de qtyChilds
 * 2. Espera 10ms con setTimeout para evitar conflictos de change detection
 * 3. Compara la cantidad deseada con la cantidad actual de controles
 * 4. Agrega controles si qtyChilds > current length
 * 5. Remueve controles si qtyChilds < current length
 *
 * @validations
 * - age: Validators.required, Validators.min(0), Validators.max(17)
 * - id: Index-based para tracking único
 *
 * @timing
 * - setTimeout(10): Permite que el cambio de qtyChilds se complete antes de ajustar el array
 *
 * @ux
 * - Proporciona una experiencia responsive al cambiar la cantidad de niños
 */
  _addChild(item: FormGroup, action: string) {
    setTimeout(() => {
      const ages: any = item.get("childsage") as FormArray;
      if (action === 'increment') {
          ages.push(
            this.fb.group({
              id: [(ages.value.length)],
              age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])],
            })
          );
      } else {
          ages.pop();
      }
    }, 10);
  }


  /**
 * Emite el estado de loading y actualiza el estado interno de búsqueda
 *
 * Este método comunica el estado de carga al componente padre y actualiza
 * la variable interna que controla la visualización del estado de búsqueda.
 *
 * @param {boolean} isLoading - Estado de carga: true si está cargando, false si completó
 * @returns {void}
 *
 * @emits
 * - isLoading: Evento boolean que indica el estado de carga
 *
 * @sideEffects
 * - Actualiza this._findData con el estado de loading
 * - Permite sincronizar el estado interno con la emisión al padre
 *
 * @usage
 * Utilizado durante las operaciones de búsqueda para mostrar/ocultar spinners
 * y prevenir interacciones duplicadas durante la carga
 */
  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }


/**
 * Compara dos fechas dentro de un string de rango de fechas para verificar si son iguales
 *
 * Este método toma un string que representa un rango de fechas, extrae las fechas individuales,
 * las formatea y compara para determinar si la fecha de llegada y salida son la misma.
 *
 * @param {any} event - String que contiene el rango de fechas en formato "fecha1,fecha2"
 * @returns {boolean} - false si las fechas son iguales, undefined si son diferentes
 *
 * @process
 * 1. Convierte el string de entrada en array usando split(",")
 * 2. Toma el primer elemento como arrivalDate y el segundo como departureDate
 * 3. Formatea ambas fechas a "YYYY-MM-DD" usando moment.js
 * 4. Compara las fechas formateadas
 *
 * @returnLogic
 * - Retorna false solo si las fechas son idénticas
 * - Retorna undefined (implícito) si las fechas son diferentes
 *
 * @usage
 * Typicalmente usado en validaciones para prevenir selección de misma fecha
 * para llegada y salida
 *
 * @example
 * compareDate("2023-12-25,2023-12-25") → false
 * compareDate("2023-12-25,2023-12-26") → undefined
 */
compareDate(event: any) {
    const getArrivalDate = moment(event.toString().split(",")[0]).format("YYYY-MM-DD");
    const getDepartureDate = moment(event.toString().split(",")[1]).format("YYYY-MM-DD");
    if (getArrivalDate === getDepartureDate) {
      return false;
    }
  }

/**
 * Actualiza dinámicamente el color de fondo del botón de agregar habitación basado en el estado hover
 *
 * Este método cambia el color de fondo del botón ".btn-choice-add" dependiendo de si el mouse
 * está sobre el botón (hover) o no, usando el color principal del cliente.
 *
 * @returns {void}
 *
 * @logic
 * - Si isHoverRoom = true: Usa bgClientColor (color principal del cliente)
 * - Si isHoverRoom = false: Usa color blanco por defecto
 *
 * @elements
 * - .btn-choice-add: Botón para agregar habitaciones
 *
 * @dependencies
 * - Requiere this.isHoverRoom para determinar estado hover
 * - Requiere this.bgClientColor configurado con color hexadecimal
 *
 * @ux
 * - Proporciona feedback visual al usuario durante hover
 * - Mantiene la consistencia de branding usando el color del cliente
 *
 * @usage
 * Llamado desde eventos mouseenter/mouseleave del botón
 */
updateButtonColorRoom() {
    const button = document.querySelector('.btn-choice-add') as HTMLElement;
    if (this.isHoverRoom) {
      button.style.backgroundColor = this.bgClientColor;
    } else {
      button.style.backgroundColor = 'white';
    }
  }


/**
 * Actualiza dinámicamente el color de fondo del botón de confirmar basado en el estado hover
 *
 * Este método cambia el color de fondo del botón ".btn-choice-confirm" dependiendo de si el mouse
 * está sobre el botón (hover) o no, usando el color principal del cliente.
 *
 * @returns {void}
 *
 * @logic
 * - Si isHoverConfirm = true: Usa bgClientColor (color principal del cliente)
 * - Si isHoverConfirm = false: Usa color blanco por defecto
 *
 * @elements
 * - .btn-choice-confirm: Botón para confirmar selección
 *
 * @dependencies
 * - Requiere this.isHoverConfirm para determinar estado hover
 * - Requiere this.bgClientColor configurado con color hexadecimal
 *
 * @ux
 * - Proporciona feedback visual al usuario durante hover
 * - Mantiene consistencia con updateButtonColorRoom
 * - Refuerza identidad visual del cliente
 *
 * @usage
 * Llamado desde eventos mouseenter/mouseleave del botón de confirmar
 */
updateButtonColorConfirm() {
    const button = document.querySelector('.btn-choice-confirm') as HTMLElement;
    if (this.isHoverConfirm) {
      button.style.backgroundColor = this.bgClientColor;
    } else {
      button.style.backgroundColor = 'white';
    }
  }

  /***********************************************Auto Complete********************************************/

  /**
 * Convierte un string a formato de título (Title Case) con manejo de valores nulos
 *
 * Este método transforma un string capitalizando la primera letra de cada palabra
 * y poniendo el resto en minúsculas, con validación robusta para valores edge.
 *
 * @param {any} val - Valor a capitalizar (se convierte a string si es posible)
 * @returns {string} - String en Title Case o valor original si no es capitalizable
 *
 * @validation
 * - Rechaza undefined, null y string vacío
 * - Retorna el valor original si no pasa validación
 *
 * @process
 * 1. toLowerCase(): Convierte todo a minúsculas
 * 2. trim(): Elimina espacios en blanco al inicio/final
 * 3. split(" "): Divide por espacios en array de palabras
 * 4. map(): Capitaliza primera letra de cada palabra
 * 5. join(" "): Une palabras con espacios
 *
 * @example
 * capitalize("new york city") → "New York City"
 * capitalize("juan pérez") → "Juan Pérez"
 * capitalize(null) → null
 */
capitalize(val: any): string {
  if (!val && val !== 0) return ''; // Manejar null, undefined, empty string, pero mantener 0

  return String(val)
    .toLowerCase()
    .trim()
    .split(/\s+/) // Divide por uno o más espacios
    .filter(word => word.length > 0) // Filtra palabras vacías
    .map(word => {
      // Encontrar el primer carácter alfabético
      const firstLetterMatch = word.match(/[a-zñáéíóúü]/i);

      if (firstLetterMatch) {
        const firstLetterIndex = firstLetterMatch.index || 0;
        // Capitalizar la primera letra alfabética encontrada
        return word.substring(0, firstLetterIndex) +
               word[firstLetterIndex].toUpperCase() +
               word.substring(firstLetterIndex + 1);
      }

      // Si no hay letras, devolver la palabra tal cual
      return word;
    })
    .join(' ');
}

  /**
 * Fuente observable para búsqueda en tiempo real de ciudades
 *
 * Este método proporciona una fuente de datos observable para componentes de
 * autocompletado, conectándose al servicio de ubicaciones para obtener resultados.
 *
 * @param {any} keyword - Término de búsqueda ingresado por el usuario
 * @returns {Observable<any[]>} - Observable que emite array de resultados de ciudades
 *
 * @uses
 * - ubicacionesService.getCitys(): Servicio que realiza la búsqueda real
 *
 * @integration
 * - Diseñado para usarse con componentes de autocompletado Angular
 * - Retorna Observable para manejo reactivo de datos
 *
 * @example
 * // Uso en componente de autocompletado
 * this.observableSource("par").subscribe(cities => {...});
 */
  observableSource = (keyword: any): Observable<any[]> => {
    return this.ubicacionesService.getCitys(keyword);
  };

  /**
 * Función de display para mostrar el valor seleccionado en campos de autocompletado
 *
 * Este método determina qué propiedad del objeto seleccionado mostrar en el input
 * después de la selección, con soporte para múltiples estructuras de datos.
 *
 * @param {any} name - Objeto seleccionado del autocompletado
 * @returns {string} - Valor a mostrar en el campo de input
 *
 * @logic
 * - Prioridad 1: name.name (para objetos con propiedad name)
 * - Prioridad 2: name.city_name (para objetos con propiedad city_name)
 * - Retorna undefined si el objeto no tiene propiedades válidas
 *
 * @supportedStructures
 * - { name: "Hotel Name" } → "Hotel Name"
 * - { city_name: "New York" } → "New York"
 *
 * @usage
 * Utilizado por componentes mat-autocomplete para display del valor seleccionado
 */
  displayFn(name: any) {
    if (name) {
      if(name.name !== undefined) {

        return `${name.name}, ${name.city_province}, ${name.country_name}`;
      }
      if (name.city_name !== undefined) {

        return `${name.city_name}, ${name.city_province}, ${name.country_name}`;
      }
    }
  }

  /**
 * Actualiza las propiedades de destino basado en la selección del usuario
 *
 * Este método procesa el objeto seleccionado del autocompletado y actualiza
 * múltiples propiedades relacionadas con el destino de viaje.
 *
 * @param {any} event - Objeto seleccionado con información de destino
 * @returns {void}
 *
 * @propertiesUpdated
 * - destiny: Nombre de la ciudad (para display)
 * - selectedDestiny: Código IATA de la ciudad (para backend)
 * - _longDestination: Nombre completo de destino
 * - country: Código IATA del país
 * - country_name: Nombre del país
 * - province_name: Provincia/estado de la ciudad (formateado)
 * - hotel_id/hotel_name: Si es hotel en lugar de ciudad
 *
 * @logic
 * - Detecta automáticamente si es ciudad o hotel
 * - Formatea province_name con comma prefix opcional
 * - Mantiene consistencia entre propiedades de display y backend
 */
  updateMySelection(event: any) {
    if (event) {
      this.destiny = event.city_name ? event.city_name : "";
      this.selectedDestiny = event.city_iata_code ?  event.city_iata_code : "";
      this._longDestination = event.city_name ? event.city_name : "";
      this.country = event.country_iata_code ? event.country_iata_code : "";
      this.country_name = event.country_name ? event.country_name : "";
      this.province_name = `${event.city_province ? ', ' : ''}${event.city_province ? event.city_province : ''}`;
      if(!this.country) {
        this.hotel_id = event.id ? event.id : "";
        this.hotel_name = event.name ? event.name : "";
        this.country = event.country_code ? event.country_code : "";

      }
    }
  }

  /**
 * Actualiza la selección de nacionalidad y sincroniza con el formulario
 *
 * Este método procesa la selección de nacionalidad, actualizando el formulario
 * y las propiedades internas con validación adecuada.
 *
 * @param {any} event - Código de país seleccionado para nacionalidad
 * @returns {void}
 *
 * @actions
 * 1. Actualiza el control de formulario 'nationality' con el valor
 * 2. Limpia errores de validación del control
 * 3. Actualiza valueAndValidity del control
 * 4. Busca y almacena el nombre del país correspondiente
 * 5. Almacena el código de país en selectNationality
 *
 * @uses
 * - filteredCountries: Array de países disponibles para búsqueda
 */
  updateMySelectionNationality(event: any) {
    if(event) {
      this._form.get('nationality').setValue(event);
      this._form.get('nationality').setErrors(null);
      this._form.get('nationality').updateValueAndValidity();
      this.selectNationalityName = this.filteredCountries.find(c => c.country_code == event)?.country_name;
      this.selectNationality = event;
    }
  }

  /**
 * Reinicia la selección de nacionalidad a estado inicial
 *
 * Este método limpia completamente la selección de nacionalidad,
 * incluyendo el control del formulario y las propiedades internas.
 *
 * @returns {void}
 *
 * @actions
 * 1. Setea el control de formulario a null
 * 2. Establece error de validación personalizado
 * 3. Limpia el nombre de nacionalidad
 * 4. Limpia el código de nacionalidad
 *
 * @validation
 * - Setea error {error: true} para indicar que es requerido
 */
  resetNationality(): void {
    this._form.get('nationality').setValue(null);
    this._form.get('nationality').setErrors({error: true});
    this.selectNationalityName = '';
    this.selectNationality = '';
  }

  /**
 * Reinicia la selección de destino a estado inicial
 *
 * Este método limpia completamente la selección de destino,
 * incluyendo el control del formulario y todas las propiedades relacionadas.
 *
 * @returns {void}
 *
 * @propertiesReset
 * - destination: Control del formulario
 * - destiny: Nombre para display
 * - selectedDestiny: Código IATA
 * - _longDestination: Nombre completo
 * - country: Código de país
 * - province_name: Nombre de provincia
 *
 * @completeness
 * - Limpia todas las propiedades relacionadas con destino
 * - No deja estado residual
 */
  resetDestiny(): void {
    this._form.get('destination').setValue(null);

    if(this.hotel_id) {
      this.hotel_id = undefined;
      this.hotel_name = '';
    }

    this.destiny = undefined;
    this.selectedDestiny = undefined;
    this._longDestination = undefined;
    this.country = undefined;
    this.province_name = undefined;
  }


  /***********************************************Auto Complete********************************************/


  /**
 * Actualiza el texto display que muestra el resumen de habitaciones y pasajeros
 *
 * Este método genera un string formateado que resume la configuración actual de
 * habitaciones, adultos y niños, con pluralización inteligente y manejo de cero selecciones.
 *
 * @returns {void}
 *
 * @process
 * 1. Obtiene cantidad de habitaciones, adultos y niños
 * 2. Determina si no hay selección (0 adultos y 0 niños)
 * 3. Aplica pluralización a habitaciones ("Habitación" vs "Habitaciones")
 * 4. Construye el string final con formato apropiado
 *
 * @format
 * - 1 Habitación - 2 Adultos - 1 Niño
 * - 2 Habitaciones - 4 Adultos - 3 Niños
 * - Rooms and passengers (cuando no hay selección)
 *
 * @pluralization
 * - rooms == 1 ? "Habitación" : "Habitaciones"
 * - Adults/Niños siempre en plural
 *
 * @ux
 * - Proporciona feedback claro de la selección actual
 * - Texto dinámico que se actualiza automáticamente
 */
  setRoomAndPassanger() {
    let rooms = this._form.value["room"].length.toString();
    let adults = this._getAdultsChildrenQty("qtyAdults", this._form.value["room"]).toString();
    let childs = this._getAdultsChildrenQty("qtyChilds", this._form.value["room"]).toString();
    let noSelected = parseInt(adults) === 0 && parseInt(childs) === 0;
    rooms = rooms == 1 ? rooms + " Habitación" : rooms + " Habitaciones";
    adults = adults != undefined ? " - " + adults + " Adultos " : null;
    childs = childs != undefined ? " - " + childs + " Niños " : null;
    if (this.isSimpleSearch) {
      this.roomsAndPassengers = `${this._getAdultsChildrenQty("qtyAdults", this._form.value["room"])} Adultos - ${this._getAdultsChildrenQty("qtyChilds", this._form.value["room"])} Niños`;
      return;
    }
    this.roomsAndPassengers = noSelected ? "Rooms and passengers" : rooms + adults + childs;
  }

  /**
 * Establece la fecha de salida mínima y abre el datepicker de regreso
 *
 * Este método asíncrono configura la fecha mínima para el datepicker de regreso
 * basado en la fecha de salida seleccionada, con apertura automática del datepicker.
 *
 * @param {any} event - Fecha de salida seleccionada
 * @returns {Promise<void>}
 *
 * @process
 * 1. Convierte la fecha a objeto Date
 * 2. Establece minDateDeparture para validaciones
 * 3. Configura opciones del datepicker para "departure"
 * 4. Abre el datepicker de regreso después de 200ms
 *
 * @timing
 * - setTimeout(200): Da tiempo para que el datepicker se renderice antes de abrirlo
 *
 * @ux
 * - Flujo automático: seleccionar salida → abre automáticamente regreso
 * - Previene selección de fechas de regreso anteriores a salida
 */
  async setDepartureDate(event: any) {
    if (event !== null) {
      this.minDateDeparture = await new Date(event);
      //this.datepickerDeparture.toggle();

      setTimeout(() => {
        this.datepickerDeparture.toggle();
      }, 200);
      return;
    }
  }

/**
 * Establece la fecha de llegada máxima para validaciones
 *
 * Este método configura la fecha máxima permitida para el datepicker de salida
 * basado en la fecha de llegada seleccionada, asegurando coherencia temporal.
 *
 * @param {any} event - Fecha de llegada seleccionada
 * @returns {void}
 *
 * @purpose
 * - Limitar la selección de fecha de salida para que no sea posterior a la llegada
 * - Mantener consistencia en el rango de fechas seleccionado
 *
 * @integration
 * - Usado en conjunction con setDepartureDate para validaciones cruzadas
 * - Actualiza maxDateArrival para las opciones del datepicker
 */
  setArrivalDate(event: any) {
    if (event !== null) {
      this.maxDateArrival = new Date(event);
      this.setOptions("arrival");
      return;
    }
  }

  /**
 * Configura las opciones de los datepickers basado en el tipo
 *
 * Este método actualiza la configuración de los datepickers (bsConfig)
 * estableciendo fechas mínimas o máximas según el tipo especificado.
 *
 * @param {String} tipo - Tipo de configuración: "departure" o otros
 * @returns {void}
 *
 * @configurations
 * - tipo = "departure": Establece minDate (fecha mínima de salida)
 * - tipo ≠ "departure": Establece maxDate (fecha máxima de llegada)
 *
 * @uses
 * - Object.assign(): Para crear nuevo objeto y evitar mutaciones
 * - this.minDateDeparture: Para fecha mínima de salida
 * - this.maxDateArrival: Para fecha máxima de llegada
 */
  setOptions(tipo: String): void {
    if (tipo != "departure") {
      this.bsConfig = Object.assign({}, { maxDate: this.maxDateArrival });
      return;
    }

    this.bsConfig = Object.assign({}, { minDate: this.minDateDeparture });
  }

  /**
 * Obtiene la lista de países disponibles desde el API
 *
 * Este método realiza una llamada HTTP para obtener todos los países
 * y los almacena para su uso en dropdowns de nacionalidad y filtros.
 *
 * @param {boolean} [researchData] - Flag opcional para indicar si se debe hacer formPatchValue después
 * @returns {void}
 *
 * @api
 * - Endpoint: GET "/utilities/countries"
 * - Service: _itineraryService._restService.doGet
 *
 * @processing
 * 1. Realiza llamada HTTP para obtener países
 * 2. Almacena en countriesData y filteredCountries
 * 3. Si researchData es true, ejecuta formPatchValue()
 *
 * @memoryManagement
 * - Usa takeUntil(this._unsubscribeAll) para evitar memory leaks
 * - Se desuscribe automáticamente cuando el componente se destruye
 */
  getCountries(researchData?: boolean) {
    this._itineraryService._restService.doGet("app", "utilities/countries")
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe({
      next: (res: any) => {
        this.countriesData = res.Countrys;
        this.filteredCountries = this.countriesData;

        if(this.filteredCountries && this.componentResults) {

          if(this.componentResultsFirstCharge) {

            this.formPatchValue();
          }
          this.componentResultsFirstCharge = false;
        }
      }
    })
  }

  /**
 * Almacena la nacionalidad seleccionada por el usuario
 *
 * Este método simple actualiza la propiedad selectNationality con el código
 * de país seleccionado para su uso posterior en búsquedas y validaciones.
 *
 * @param {string} nationalitySelected - Código de país seleccionado (ej: "US", "MX")
 * @returns {void}
 *
 * @purpose
 * - Mantener un registro de la selección actual de nacionalidad
 * - Preparar el valor para el payload de búsqueda
 *
 * @note
 * - Solo almacena el valor, no actualiza el formulario directamente
 */
  selectedNationality(nationalitySelected: string) {
    this.selectNationality = nationalitySelected;
  }

  /**
 * Activa y muestra el modal en la interfaz
 *
 * Este método cambia el estado para mostrar un modal/dialog en la UI,
 * típicamente usado para confirmaciones o información adicional.
 *
 * @returns {void}
 *
 * @stateChange
 * - showModal: false → true
 *
 * @usage
 * Llamado desde eventos de click o acciones del usuario que requieren modal
 */
  fileActive() {
      this.showModal = true;
  }

  /**
 * Cierra y oculta el modal de la interfaz
 *
 * Este método cambia el estado para ocultar el modal/dialog actualmente visible,
 * restaurando el foco a la interfaz principal.
 *
 * @returns {void}
 *
 * @stateChange
 * - showModal: true → false
 *
 * @usage
 * Llamado desde botones de cerrar o clicks fuera del modal
 */
  closeModal() {
    this.showModal = false;
  }

  /**
 * Confirma la acción del modal y lo cierra
 *
 * Este método maneja la acción de confirmación en modales,
 *典型mente ejecutando alguna lógica y luego cerrando el modal.
 *
 * @returns {void}
 *
 * @actions
 * 1. Ejecuta lógica de confirmación (si aplica)
 * 2. Cierra el modal llamando closeModal()
 *
 * @note
 * - Actualmente solo cierra el modal, puede extenderse para más funcionalidad
 */
  confirmAction() {
    this.closeModal();
  }

  /**
 * Filtra la lista de países basado en el texto de búsqueda ingresado
 *
 * Este método filtra el array de países disponibles (countriesData) para mostrar
 * solo aquellos cuyo nombre coincide con el texto de búsqueda, con búsqueda case-insensitive.
 *
 * @param {string} searchText - Texto de búsqueda ingresado por el usuario
 * @returns {void}
 *
 * @filterLogic
 * - Si searchText existe: Filtra países que contengan el texto (case-insensitive)
 * - Si searchText está vacío/null/undefined: Muestra todos los países
 *
 * @searchBehavior
 * - Búsqueda parcial: includes() en lugar de igual exacto
 * - Case-insensitive: Convierte ambos lados a minúsculas
 * - Tiempo real: Se ejecuta con cada cambio en el input de búsqueda
 *
 * @performance
 * - Filtrado client-side: No requiere llamadas adicionales al API
 * - Operación sincrónica: Respuesta inmediata
 *
 * @example
 * // searchText = "mex" → muestra "Mexico"
 * // searchText = "uni" → muestra "United States", "United Kingdom"
 * // searchText = "" → muestra todos los países
 */
  filterCountries(searchText: string) {
    if (searchText) {
      this.filteredCountries = this.countriesData.filter(country =>
        country.country_name.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      this.filteredCountries = this.countriesData;
    }
  }

  /**
 * Función de display para mostrar el nombre del país en campos de selección
 *
 * Este método toma un código de país y retorna el nombre correspondiente
 * para mostrar en interfaces de usuario, con manejo de errores robusto.
 *
 * @param {any} country - Código de país (ej: "US", "MX") o null
 * @returns {string} - Nombre del país o string vacío si no se encuentra
 *
 * @process
 * 1. Verifica que filteredCountries esté definido
 * 2. Busca el país por country_code en filteredCountries
 * 3. Maneja caso especial cuando country es null
 * 4. Retorna el country_name o string vacío
 *
 * @errorHandling
 * - Console.error si filteredCountries no está definido
 * - Retorna string vacío en casos de error o no encontrado
 *
 * @usage
 * Utilizado por componentes de selección (dropdowns, autocomplete)
 * para mostrar nombres amigables en lugar de códigos
 *
 * @example
 * displayCountry("US") → "United States"
 * displayCountry("MX") → "Mexico"
 * displayCountry(null) → ""
 */
  displayCountry = (country: any) => {
    if (!this.filteredCountries) {
      console.error('filteredCountries is not defined');
      return '';
    }
    let countryData = this.filteredCountries.find(c => c.country_code === country);
    if(country === null) {
      countryData = null;
    }
    return countryData ? `${countryData.country_name}` : '';
  }

  /**
 * Cierra el dialog actual retornando null como resultado
 *
 * Este método cierra el dialog/modal actual sin retornar ningún dato específico,
 *典型mente usado para cancelar operaciones o cerrar dialogs de información.
 *
 * @returns {void}
 *
 * @behavior
 * - Cierra el dialog referencia por this.dialogRef
 * - Retorna null como resultado del dialog
 * - No ejecuta acciones adicionales de limpieza
 *
 * @ux
 * - Permite al usuario cerrar dialogs sin realizar acciones
 * - Proporciona una forma estándar de cerrar componentes dialógicos
 *
 * @integration
 * - Usado con Angular Material Dialog o similar
 * - dialogRef.close(null) indica que no hay datos que retornar
 */
    close(): void {

    this.dialogRef.close(null);
  }

  filePaid():void{
    if(this.validateButtonSearch){
      this.titleModal = 'File Completado',
      this.messageModal = 'Este file se encuentra completado, por favor, crea un nuevo file para hacer una búsqueda'
      this.showModal = true;
    }
  }

  /**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

/**
 * Devuelve el rango de fechas seleccionado como string formateado "DD/MM/YYYY - DD/MM/YYYY"
 * para mostrar en el input visible. Si no hay rango completo, devuelve string vacío.
 */
get dateRangeLabel(): string {
  const start = this.dateRange?.start;
  const end = this.dateRange?.end;
  if (!start || !end) return '';
  const fmt = (d: any) => dayjs(d).format('DD/MM/YYYY');
  return `${fmt(start)} - ${fmt(end)}`;
}


incrementPassengerAdult(index: number, event?: Event) {

      if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const roomsArray = this._form.get('room') as FormArray;
    const roomGroup = roomsArray.at(index) as FormGroup;

    // Obtener valor actual
    const currentValue = roomGroup.get('qtyAdults')?.value || 0;

    // Validar máximo
    if (currentValue >= 10) return;

    // Actualizar usando patchValue (método reactivo)
    roomGroup.patchValue({
        qtyAdults: currentValue + 1
    });
}

decrementPassengerAdult(index: number, event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const roomsArray = this._form.get('room') as FormArray;
    const roomGroup = roomsArray.at(index) as FormGroup;

    // Obtener valor actual
    const currentValue = roomGroup.get('qtyAdults')?.value || 0;

    // Validar mínimo (mínimo 1 adulto)
    if (currentValue <= 1) return;

    // Actualizar usando patchValue
    roomGroup.patchValue({
        qtyAdults: currentValue - 1
    });
}

incrementPassengerChildren(index: number, item: FormGroup, event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }



    const roomsArray = this._form.get('room') as FormArray;
    const roomGroup = roomsArray.at(index) as FormGroup;

    // Obtener valor actual
    const currentValue = roomGroup.get('qtyChilds')?.value || 0;

    // Validar máximo
    if (currentValue >= 10) return;

    // Actualizar usando patchValue
    roomGroup.patchValue({
        qtyChilds: currentValue + 1
    });

    // Añadir control de edad para el nuevo niño
    const ages = item.get("childsage") as FormArray;
    ages.push(this.fb.group({
        id: [currentValue],
        age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
    }));
}

decrementPassengerChildren(index: number, item: FormGroup, event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const roomsArray = this._form.get('room') as FormArray;
    const roomGroup = roomsArray.at(index) as FormGroup;

    // Obtener valor actual
    const currentValue = roomGroup.get('qtyChilds')?.value || 0;

    // Validar mínimo
    if (currentValue <= 0) return;

    // Actualizar usando patchValue
    roomGroup.patchValue({
        qtyChilds: currentValue - 1
    });

    // Eliminar control de edad del último niño
    const ages = item.get("childsage") as FormArray;
    if (ages.length > 0) {
        ages.removeAt(ages.length - 1);
    }
}

getPassengerCountAdult(index: number): number {
    const roomsArray = this._form.get('room') as FormArray;
    const roomGroup = roomsArray.at(index) as FormGroup;
    return roomGroup.get('qtyAdults')?.value || 0;
}

getPassengerCountChildren(index: number): number {
    const roomsArray = this._form.get('room') as FormArray;
    const roomGroup = roomsArray.at(index) as FormGroup;
    return roomGroup.get('qtyChilds')?.value || 0;
}

  validatePassengerInput(event: any, index: number) {

        if (event) {
          event.stopPropagation(); // Evita que el clic se propague
          event.preventDefault();  // Previene comportamiento por defecto
      }

      const inputValue = parseInt(event.target.value, 10);
      const roomsArray = this._form.get('room') as FormArray;
      const roomGroup = roomsArray.at(index) as FormGroup;

      // Determinar si es adulto o niño (podrías pasar un parámetro)
      const isAdult = event.target.name === 'adults'; // Asigna nombres a los inputs

      if (isAdult) {
          // Validar adultos (1-10)
          const validatedValue = Math.max(1, Math.min(10, isNaN(inputValue) ? 1 : inputValue));
          roomGroup.patchValue({ qtyAdults: validatedValue });
      } else {
          // Validar niños (0-10)
          const validatedValue = Math.max(0, Math.min(10, isNaN(inputValue) ? 0 : inputValue));
          roomGroup.patchValue({ qtyChilds: validatedValue });

          // Ajustar array de edades
          this.adjustChildrenAges(index, validatedValue);
      }
  }

private adjustChildrenAges(roomIndex: number, newChildCount: number): void {
    const roomGroup = (this._form.get('room') as FormArray).at(roomIndex) as FormGroup;
    const ages = roomGroup.get("childsage") as FormArray;
    const currentCount = ages.length;

    if (newChildCount > currentCount) {
        // Agregar edades faltantes
        for (let i = currentCount; i < newChildCount; i++) {
            ages.push(this.fb.group({
                id: [i],
                age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
            }));
        }
    } else if (newChildCount < currentCount) {
        // Eliminar edades excedentes
        while (ages.length > newChildCount) {
            ages.removeAt(ages.length - 1);
        }
    }
}

// Agrega estos métodos a tu componente

handleAdultInput(event: any, index: number): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    // Prevenir entrada de 0 como primer dígito
    if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
        return;
    }

    // Solo permitir números
    if (!/^\d$/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        return;
    }
}

handleAdultBlur(event: any, index: number): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const value = event.target.value.trim();

    if (value === '' || value === '0' || isNaN(parseInt(value, 10))) {
        const roomsArray = this._form.get('room') as FormArray;
        const roomGroup = roomsArray.at(index) as FormGroup;
        roomGroup.patchValue({ qtyAdults: 1 });
        event.target.value = '1';
    }

    if(value !== '' && parseInt(value, 10) > 10) {
      const numericValue = parseInt(value, 10);
      event.target.value = numericValue.toString();

      const roomsArray = this._form.get('room') as FormArray;
      const roomGroup = roomsArray.at(index) as FormGroup;
      roomGroup.patchValue({ qtyAdults: 10 });
      event.target.value = '10';
    }

}


handleChildrenInput(event: any, index: number): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const currentValue = event.target.value;

    // Si está vacío y se presiona 0, prevenir
    if (event.key === '0' && currentValue === '') {
        event.preventDefault();
        return;
    }

    // Solo permitir números
    if (!/^\d$/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        return;
    }

    // Prevenir que escriba más de 2 dígitos (para edades hasta 17)
    if (/^\d$/.test(event.key) && currentValue.length >= 2) {
        event.preventDefault();
        return;
    }
}

handleChildrenBlur(event: any, index: number): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const value = event.target.value.trim();

    // Si está vacío, poner 0
    if (value === '' || isNaN(parseInt(value, 10))) {
        const roomsArray = this._form.get('room') as FormArray;
        const roomGroup = roomsArray.at(index) as FormGroup;
        roomGroup.patchValue({ qtyChilds: 0 });
        event.target.value = '0';
        this.adjustChildrenAges(index, 0);
    } else {
        // Si tiene un valor válido, asegurarse de que no tenga ceros a la izquierda
        const numericValue = parseInt(value, 10);
        event.target.value = numericValue.toString();

        const roomsArray = this._form.get('room') as FormArray;
        const roomGroup = roomsArray.at(index) as FormGroup;
        roomGroup.patchValue({ qtyChilds: numericValue });
        this.adjustChildrenAges(index, numericValue);
    }
}

preventModalClose(event: MouseEvent): void {
    // Detiene la propagación del evento click para que no llegue al listener
    // que cierra el modal
    event.stopPropagation();
    event.preventDefault();

    // Opcional: Forzar el foco en el input
    const target = event.target as HTMLInputElement;
    target.focus();
}

agesChildsArr(): string[] {
    return Array.from({length: 18}, (_, index) => {
        return index.toString();
    });
}

getCardTransform(): string {
  if (!this.componentResults) {
    return 'translateY(0px)';
  }

  // Encontrar cuarto con más niños
  let maxChildrenCount = 0;
  let totalRooms = 0;
  const roomsArray = this._form.get('room') as any;

  if (roomsArray && roomsArray.controls) {
    totalRooms = roomsArray.controls.length;
    roomsArray.controls.forEach((room: any) => {
      const childrenCount = room.get('childsage')?.value?.length || 0;
      if (childrenCount > maxChildrenCount) {
        maxChildrenCount = childrenCount;
      }
    });
  }

  // Calcular desplazamiento
  let translateY = 0;

  if (totalRooms >= 1) {
    // Cuartos: máximo 3 cuartos = 300px
    const maxRoomsToCount = 3;
    const roomsToCount = Math.min(totalRooms, maxRoomsToCount);
    const roomsOffset = roomsToCount * 100;

    // Niños: solo el máximo por cuarto
    const childrenOffset = maxChildrenCount * 150;

    // Total
    translateY = -(roomsOffset + childrenOffset);

    // Límite
    const MAX_OFFSET = 600;
    if (Math.abs(translateY) > MAX_OFFSET) {
      translateY = -MAX_OFFSET;
    }
  }

  return `translateY(${translateY}px)`;
}

  // ============================================
  // MÉTODOS DE PERSONALIZACIÓN DE UI
  // ============================================

  /**
   * Aplica filtro de color a los iconos basado en configuración del cliente
   * Convierte el color principal del cliente a filtro CSS
   */
  applyImageFilter() {
    const color = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;

    if (!color) {
      console.warn('No color defined');
      return;
    }

    try {
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";
      const filter = colorFilter;

      this.iconInfo.nativeElement.style.filter = filter;


    } catch (error) {
      console.error('Error applying image filter:', error);
    }
  }

  repositionCard(force = false) {
  if (!this.cardSelectorRoom || !this.triggerButton || !this.isCollapsed) {
    return;
  }

  const card = this.cardSelectorRoom.nativeElement;
  const trigger = this.triggerButton.nativeElement;

  // Si es la primera vez o forzamos el reposicionamiento
  if (!this.initialPositioning || force) {
    // Asegurar que la tarjeta sea visible y tenga dimensiones
    card.style.display = 'block';
    card.style.visibility = 'hidden';
    card.style.opacity = '0';

    // Forzar un reflow para calcular dimensiones
    card.offsetHeight;

    // Obtener dimensiones después del reflow
    const cardRect = card.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();

    // Guardar altura para cálculos posteriores
    this.cardHeight = cardRect.height;

    // Calcular posición inicial (abajo del botón)
    let top = triggerRect.bottom + window.scrollY;
    let left = triggerRect.left + window.scrollX;

    // Ajustar si no cabe en la pantalla
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    // Si no cabe abajo, mostrar arriba
    if (top + this.cardHeight > viewportHeight + window.scrollY) {
      top = triggerRect.top + window.scrollY - this.cardHeight - 5;
    }

    // Si no cabe a la derecha, ajustar
    if (left + cardRect.width > viewportWidth) {
      left = viewportWidth - cardRect.width - 10;
    }

    // Aplicar posición
    card.style.position = 'fixed';
    card.style.top = `${top}px`;
    card.style.left = `${left}px`;
    card.style.zIndex = '1060';

    // Hacer visible
    setTimeout(() => {
      card.style.visibility = 'visible';
      card.style.opacity = '1';
      this.initialPositioning = true;
    }, 10);
  }

  // Ajustar scroll si es necesario
  this.adjustScrollPosition();
}

toggleCard(event?: Event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  this.isCollapsed = !this.isCollapsed;

  if (this.isCollapsed) {
    // Resetear flag para forzar reposicionamiento
    this.initialPositioning = false;

    // Esperar a que Angular renderice los cambios
    setTimeout(() => {
      this.repositionCard(true);
    }, 50); // Tiempo suficiente para renderizar cambios
  }
}

adjustScrollPosition() {
  if (!this.cardSelectorRoom || !this.isCollapsed) {
    return;
  }

  const card = this.cardSelectorRoom.nativeElement;
  const cardRect = card.getBoundingClientRect();
  const viewportHeight = window.innerHeight;

  // Calcular qué parte de la tarjeta está visible
  const cardBottom = cardRect.bottom;
  const cardTop = cardRect.top;

  // Si la tarjeta se sale por abajo
  if (cardBottom > viewportHeight) {
    // Calcular cuánto scroll necesitamos
    const scrollNeeded = cardBottom - viewportHeight + 20;

    // Hacer scroll suave
    window.scrollTo({
      top: window.scrollY + scrollNeeded,
      behavior: 'smooth'
    });
  }

  // Si la tarjeta se sale por arriba
  if (cardTop < 0) {
    const scrollNeeded = cardTop - 20;

    window.scrollTo({
      top: window.scrollY + scrollNeeded,
      behavior: 'smooth'
    });
  }
}

isDateRangeValid(): boolean {

    if(this._form && this._form.get('arrivalDateDepartureDate')?.touched &&
          !this.dateRange &&
          !this.dateRange.start &&
          !this.dateRange.end) {
            return true;
      } else {
        this.dateRangeInvalid = false;
      }

      return false;
}

/**
   * Detecta cambios en el date range picker
   */
  // onDateRangeChange(event: any): void {
  //   if (this.isSyncing) return;
  //   this.isSyncing = true;

  //   // Obtener las fechas actuales de los calendarios
  //   const picker = this.dateRangePicker;
  //   if (picker && picker.picker) {
  //     const leftDate = picker.picker.leftCalendar?.firstDate;
  //     const rightDate = picker.picker.rightCalendar?.firstDate;
  //     // Sincronizar: si el izquierdo avanzó, el derecho también
  //     if (leftDate && this.currentLeftDate && leftDate > this.currentLeftDate) {
  //       this.syncCalendar(leftDate, 'right');
  //     }

  //     // Sincronizar: si el derecho retrocedió, el izquierdo también
  //     if (rightDate && this.currentRightDate && rightDate < this.currentRightDate) {
  //       this.syncCalendar(rightDate, 'left');
  //     }

  //     this.currentLeftDate = leftDate;
  //     this.currentRightDate = rightDate;
  //   }

  //   setTimeout(() => { this.isSyncing = false; }, 100);
  // }

  // /**
  //  * Sincroniza los calendarios
  //  */
  // private syncCalendar(date: Date, target: 'left' | 'right'): void {
  //   const picker = this.dateRangePicker;
  //   if (!picker || !picker.picker) return;

  //   if (target === 'right') {
  //     // Establecer la misma fecha en el calendario derecho
  //     picker.picker.rightCalendar = {
  //       ...picker.picker.rightCalendar,
  //       firstDate: date,
  //       lastDate: new Date(date.getFullYear(), date.getMonth() + 1, 0)
  //     };
  //   } else {
  //     picker.picker.leftCalendar = {
  //       ...picker.picker.leftCalendar,
  //       firstDate: date,
  //       lastDate: new Date(date.getFullYear(), date.getMonth() + 1, 0)
  //     };
  //   }
  // }

}


